import { z } from 'zod';

import { type SupportedResourceType, supportedResourceSet } from './resources';

export type {
  TwilioConversation,
  TwilioConversationMessage,
  TwilioConversationParticipant,
  TwilioParticipantConversation,
} from './client';

const UUIDSchema = z.string().uuid();

const ReferenceSchema = z.string().refine((value) => {
  const parts = value.split('/');
  // TODO: validate resourceType
  if (parts.length !== 2) {
    return false;
  }

  const [resourceType, id] = parts;

  if (!supportedResourceSet.has(resourceType as SupportedResourceType)) {
    return false;
  }

  const parsedId = UUIDSchema.safeParse(id);

  return parsedId.success;
});

const DisplayReferenceSchema = z.object({
  reference: ReferenceSchema.optional(),
  display: z.string().optional(),
});

export const MessageIdRequestSchema = z.object({
  messageId: z.string(),
});

export const ConversationAlertSchema = z.object({
  patient: DisplayReferenceSchema,
  alert: z.boolean(),
  sent: z.string(),
});

export const ConversationAlertGetAllResponseSchema = z.array(
  ConversationAlertSchema,
);

export type ConversationAlert = z.infer<typeof ConversationAlertSchema>;

export type ConversationAlertGetAllResponse = z.infer<
  typeof ConversationAlertGetAllResponseSchema
>;
